export default __webpack_public_path__ + "static/targ-img-1-0eccd7d3e4a7c95e001fe1e85611e913.png";